import { FC } from 'react';
import { Skeleton } from 'antd';
import Paper from 'components/atoms/Paper';
import { useAssetGateway } from './resources/useAssetGateways';
import { NoGatewayAssigned } from './NoGatewayAssigned';
import GatewayStatus from './GatewayStatus';
import ConfirmUnAssignGatewayModal from 'components/molecules/ConfirmUnAssignGatewayModal';
import ConfirmModal from 'components/molecules/ConfirmModal';

const TabGateway: FC = () => {
  const {
    assetId,
    gatewaysOptions,
    gatewayActionsOptions,
    loading
  } = useAssetGateway();

  const {
    gateways,
    gatewayStatusInformationTranslations,
    onUpdateGateway,
    hasPermissionToEditGatewayLink,
  } = gatewaysOptions;

  const {
    rebootOptions,
    hasLinkedGateway,
    onAssignGateway,
    unassignTranslations,
    onUnassignGateway,
    onConfirmUnassignGateway,
    loadingGatewayAssignation,
    onCancelConfirmationOnUnAssignGatewayModal,
    showConfirmationOnUnassignGatewayModal,
  } = gatewayActionsOptions;

  const {
    confirmationOnUnassignGatewayModalTitle,
    confirmationOnUnassignGatewayModalText,
    confirmationOnUnassignGatewayModalMainButtonText,
    confirmationOnUnassignGatewayModalSecondaryButtonText,
  } = unassignTranslations;

  const {
    rebootGatewayLiterals: {
      rebootGatewayModalText,
      rebootGatewayModalTitle,
      rebootGatewayModalMainButtonText,
      rebootGatewayModalSecondaryButtonText,
    },
    onRebootGateway,
    onCancelRebootGateway,
    onConfirmRebootGateway,
    isRebootGatewayLoading,
    isRebootGatewayModalVisible,
    hasPermissionToRebootGateway,
    isConfirmRebootGatewayButtonDisabled,
  } = rebootOptions;

  return (
    <>
      {loading && (
        <Paper>
          <Skeleton active />
        </Paper>
      )}
      {!loading && !hasLinkedGateway && (
        <NoGatewayAssigned
          assetId={assetId}
          onAssignGateway={onAssignGateway}
          hasPermissionToEditGatewayLink={hasPermissionToEditGatewayLink}
        />
      )}
      {!loading && hasLinkedGateway && (
        <>
          {gateways.map((gateway) => {
            return (
              <div key={gateway.id}>
                <Paper>
                  <GatewayStatus
                    gateway={gateway}
                    informationTranslations={gatewayStatusInformationTranslations}
                    onUnassignGateway={() => onUnassignGateway(gateway.id)}
                    onUpdateGateway={onUpdateGateway}
                    onRebootGateway={() => onRebootGateway(gateway.isRebootable, gateway.id)}
                    hasPermissionToEditGatewayLink={hasPermissionToEditGatewayLink}
                    isGatewayLinked={!!gateway.assetId}
                    hasPermissionToRebootGateway={hasPermissionToRebootGateway}
                  />
                </Paper>
              </div>
            )
          })}
        </>
      )}
      <ConfirmUnAssignGatewayModal
        title={confirmationOnUnassignGatewayModalTitle}
        text={confirmationOnUnassignGatewayModalText}
        mainButtonText={confirmationOnUnassignGatewayModalMainButtonText}
        secondaryButton={confirmationOnUnassignGatewayModalSecondaryButtonText}
        onClick={onConfirmUnassignGateway}
        open={showConfirmationOnUnassignGatewayModal}
        confirmLoading={loadingGatewayAssignation}
        onCancel={onCancelConfirmationOnUnAssignGatewayModal}
      />
      <ConfirmModal
        text={rebootGatewayModalText}
        title={rebootGatewayModalTitle}
        mainButtonText={rebootGatewayModalMainButtonText}
        secondaryButtonText={rebootGatewayModalSecondaryButtonText}
        onCancel={onCancelRebootGateway}
        onClickMainButton={onConfirmRebootGateway}
        loading={isRebootGatewayLoading}
        visible={isRebootGatewayModalVisible}
        isMainButtonDisabled={isConfirmRebootGatewayButtonDisabled}
      />
    </>
  );
};

export default TabGateway;
